import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {Translate, I18n} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';
import {Tooltip} from '@material-ui/core';
import {STATUS} from './utils/status';
import authenticationService from '../../../../../services/authentication/AuthenticationService';
import subscriptionService from '../../../../../services/subscription/SubscriptionService';
import {openOrSaveFile} from '../../../../../utils/http';

function InvoiceView({invoice}) {
  const organisation = useSelector(state => state.organisation);
  const address = invoice.billingAddress;
  const statusColor = {
    [STATUS.PAID]: 'success',
    [STATUS.PAYMENT_DUE]: 'warning',
    [STATUS.NOT_PAID]: 'warning',
    [STATUS.POSTED]: 'warning'
  };
  let paymentMessage = null;

  if (invoice.status === STATUS.PAID) {
    paymentMessage = (
      <Translate
        tag="div"
        value="invoices.paidOn"
        date={I18n.l(invoice.date, {dateFormat: 'datetime.shortDate'})}
      />
    );
  } else if (invoice.dueDate) {
    paymentMessage = (
      <Translate
        tag="div"
        value="invoices.dueOn"
        date={I18n.l(invoice.date, {dateFormat: 'datetime.shortDate'})}
      />
    );
  }

  function handleDownload() {
    authenticationService.authRedirect(subscriptionService.getInvoiceUrl(organisation.organisationId, invoice.id))
      .then(authUrl => openOrSaveFile(authUrl));
  }

  function renderAmount(amount) {
    return (amount / 100).toFixed(2);
  }

  return (
    <>
      <div className="row py-4">
        <div className="col-12 col-lg-3">
          <h3><strong>{invoice.id}</strong></h3>
          <Translate
            value="invoices.creationDate"
            date={I18n.l(invoice.date, {dateFormat: 'datetime.shortDate'})}
          />
          {paymentMessage}
        </div>
        <div className="col-12 col-lg-3">
          <h3 className="font-size-m"><Translate value="invoices.sentTo"/></h3>
          <div>{address.firstName}&nbsp;{address.lastName}</div>
          {address.company && <div>{address.company}</div>}
          <div>{address.line1}</div>
          <div>{address.zip}&nbsp;{address.city}</div>
        </div>
        <div className="col-12 col-lg-3">
          <h3 className="font-size-m"><Translate value="invoices.amountTotal"/></h3>
          <div>{renderAmount(invoice.totalAmount)}&euro;</div>
          {invoice.dueAmount > 0 &&
            <>
              <h3 className="font-size-m mt-3"><Translate value="invoices.amountDue"/></h3>
              <div>{renderAmount(invoice.dueAmount)}&euro;</div>
            </>
          }
        </div>
        <div className="col-12 col-lg-2">
          <h3 className="font-size-m"><Translate value="invoices.statusTitle"/></h3>
          <div className={`chip ${statusColor[invoice.status]}`}>
            <strong><Translate value={`invoices.status.${invoice.status}`}/></strong>
          </div>
        </div>
        <div className="col-12 col-lg-1 d-flex justify-content-end align-items-center">
          <Tooltip title={<Translate value="invoices.download"/>}>
            <button
              data-id="download-button"
              type="button"
              className="large primary"
              onClick={handleDownload}
            >
              <Icon icon="download"/>
            </button>
          </Tooltip>
        </div>
      </div>
      <hr/>
    </>
  );
}

InvoiceView.propTypes = {
  invoice: PropTypes.object.isRequired
};

export default InvoiceView;
